/** Tokens visuais — avaliações loja (marca TNV) */
export const AVALIACOES_ACCENT = "#F96030";
export const AVALIACOES_INK = "#1a2035";

export const avaliacoesToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${AVALIACOES_ACCENT}`,
};

export const avaliacoesTabsSx = {
  mb: 2,
  minHeight: 48,
  borderBottom: "1px solid",
  borderColor: "grey.200",
  "& .MuiTab-root": {
    textTransform: "none",
    fontWeight: 600,
    minHeight: 48,
  },
  "& .Mui-selected": {
    color: `${AVALIACOES_ACCENT} !important`,
  },
  "& .MuiTabs-indicator": {
    backgroundColor: AVALIACOES_ACCENT,
    height: 3,
  },
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
};

export const statusToggleSx = {
  flexWrap: "wrap" as const,
  "& .MuiToggleButton-root": {
    px: 1.25,
    py: 0.75,
    textTransform: "none" as const,
    fontSize: "0.8125rem",
    "&.Mui-selected": {
      bgcolor: "rgba(249, 96, 48, 0.1)",
      borderColor: AVALIACOES_ACCENT,
      color: AVALIACOES_ACCENT,
      fontWeight: 600,
    },
  },
};

export const emptyStateSx = {
  py: 6,
  textAlign: "center",
  border: "1px dashed",
  borderColor: "grey.300",
  borderRadius: 2,
  bgcolor: "grey.50",
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${AVALIACOES_ACCENT}, #e04a1a)`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 720,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  flexShrink: 0,
  background: `linear-gradient(135deg, ${AVALIACOES_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${AVALIACOES_ACCENT}`,
};

export const gridSx = {
  border: "1px solid",
  borderColor: "grey.200",
  borderRadius: 2,
  minHeight: 420,
  "& .MuiDataGrid-row": { cursor: "pointer" },
  "& .MuiDataGrid-row:hover": {
    bgcolor: "rgba(249, 96, 48, 0.04)",
  },
  "& .MuiDataGrid-columnHeaders": {
    bgcolor: "grey.100",
    fontWeight: 700,
  },
  "& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
  },
};
